import { render, staticRenderFns } from "./CustomerData.vue?vue&type=template&id=12cc5a22"
import script from "./CustomerData.vue?vue&type=script&lang=js"
export * from "./CustomerData.vue?vue&type=script&lang=js"
import style0 from "./CustomerData.vue?vue&type=style&index=0&id=12cc5a22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports